import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { connect, useDispatch } from "react-redux";

// ANT DESIGN IMPORTS
import {
  ConfigProvider,
  Input,
  Row,
  Typography,
  Col,
  Card,
  Table,
  Spin,
  Select,
  Button,
} from "antd";

// PROJECT IMPORTS
import tableData from "../../../config/data/savings.json";
import { CSVLink } from "react-csv";
import MainLayout from "../../../components/layouts/MainLayout";
import TopContent from "../../../components/layouts/TopContent";
import appStatic from "../../../config/appStatic";
import appLabel from "../../../config/appLabel";
import StatusSelect from "../../../components/StatusSelect";
import definedApi from "../../../services/definedApi";
import { BOM } from "../../../services/definedMethod";
import cnt from "../../../services/definedConstant";
import DownloadTableButtons from "../../../components/DownloadTableButtons";

import { rightAction } from "../../../redux/actions";

const columns = [
  {
    title: "Financial Activity",
    dataIndex: "financialActivity",
    sorter: (a, b) => a.financialActivity.localeCompare(b.financialActivity),
  },
  {
    title: "Account Name",
    dataIndex: "accountName",
    sorter: (a, b) => a.accountName.localeCompare(b.accountName),
  },
  ,
];

const GLA0400 = (props) => {
  //DECLARED VARIABLES
  const { userData, rightBtn, rightAction } = props;
  const { session } = userData;
  const { Text } = Typography;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState([]);
  const [selectedRow, setSelectedRow] = useState(null);
  const [tableCount, setTableCount] = useState("10");
  const [glMappingList, setGLMappingList] = useState([]);
  const [originalList, setOriginalList] = useState([]);

  useEffect(() => {
    BOM.HasPermission("READ_FINANCIALACTIVITYACCOUNT") && getGLMappingListAction();
    // //DISABLE ALL RIGHTSIDEBAR ACTION
    // dispatch({
    //   type: cnt.CLEAR_RIGHT_BTN,
    // });
    BOM.HasPermission("CREATE_FINANCIALACTIVITYACCOUNT") && rightAction(cnt.RIGHT_ADD_BTN);
  }, []);

  const getGLMappingListAction = () => {
    let body = {
      session,
    };

    BOM.FetchReqAction(body, definedApi.GetGLMappingList, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
      } else {
        const objList = res;
        let tempArray = [];

        objList.forEach((element) => {
          tempArray.push({
            key: element?.id,
            financialActivity: element?.financialActivityData.mappedGLAccountType
              ? element?.financialActivityData.name
                  .replace(/([a-z])([A-Z])/g, "$1 $2")
                  .toUpperCase()
              : "No Description",
            accountName: element?.glAccountData.name
              ? element?.glAccountData.name
              : "No Account Date",
          });
        });

        //Display only active records list on the table; this will change after switching from authorized to disabled and vice versa.
        // setGLMappingList(tempArray.filter((item) => item.disabled === false));
        setGLMappingList(tempArray);

        //keep the orginal data to use after gList is modified when change from autorise to disable
        setOriginalList(tempArray);

        //STOP LOAD
        setIsLoading(false);
      }
    });
  };

  const getCsvListData = () => {
    return new Promise((resolve, reject) => {
      const params = {
        limit: 1000,
        offset: 0,
      };

      let body = {
        session,
        params,
      };

      BOM.FetchReqAction(body, definedApi.GetGLMappingList, (err, res) => {
        if (err) {
          reject(err);
        } else {
          const objList = res;
          let tempArray = [];

          objList.forEach((element) => {
            tempArray.push({
              key: element?.id,
              financialActivity: element?.financialActivityData.mappedGLAccountType
                ? element?.financialActivityData.name
                    .replace(/([a-z])([A-Z])/g, "$1 $2")
                    .toUpperCase()
                : "No Description",
              accountName: element?.glAccountData.name
                ? element?.glAccountData.name
                : "No Account Date",
            });
          });

          resolve(tempArray);
        }
      });
    });
  };

  //DECLARED METHODS
  const onSelectItemAction = (selectedRowKeys, objParam) => {
    // console.log(selectedRowKeys);
    console.log(objParam);

    //HOLD THE OBJECT SELECTED HERE
    setSelectedRow(objParam[0]);
    [
      BOM.HasPermission("READ_FINANCIALACTIVITYACCOUNT") && cnt.RIGHT_DETAIL_BTN,
      BOM.HasPermission("UPDATE_FINANCIALACTIVITYACCOUNT") && cnt.RIGHT_EDIT_BTN,
    ].map((item) => {
      dispatch({
        type: item,
      });
    });
  };

  function handleStatusChange(value) {
    console.log(value);
    // let tempList = originalList;

    // switch (value.toLowerCase()) {
    //   case "authorised":
    //     tempList = originalList.filter((item) => item.disabled === false);
    //     break;
    //   case "disabled":
    //     tempList = originalList.filter((item) => item.disabled === true);
    //     break;
    //   default:
    //     return tempList;
    // }

    // setGLMappingList(tempList);
  }

  function handleSearchInTable(searchKey) {
    searchKey = searchKey.target.value.toLowerCase();

    if (!searchKey) {
      setGLMappingList(originalList);
      return;
    }
    const filterBySearch = originalList.filter(
      (item) =>
        item?.key === parseInt(searchKey) ||
        item?.financialActivity?.toLowerCase().includes(searchKey)
    );
    setGLMappingList(filterBySearch);
  }

  function selectTableCount(value) {
    setTableCount(value);
  }

  function handleOnView() {
    console.log(selectedRow);
    const { detailBtn } = rightBtn;
    if (detailBtn.toLowerCase() === "primary") {
      navigate("/view-gla0400", { state: selectedRow });
    } else {
      console.log("Please choose a record from the table to open");
    }
  }

  function handleOnCreate() {
    const { addBtn } = rightBtn;
    if (addBtn.toLowerCase() === "primary") {
      navigate("/add-gla0400", { ofObj: selectedRow });
    } else {
      console.log("Could not open the link");
    }
  }

  function handleOnEdit() {
    // console.log(selectedRow);
    const { editBtn } = rightBtn;
    if (editBtn.toLowerCase() === "primary") {
      navigate("/edit-gla0400", { state: selectedRow });
    } else {
      console.log("Please choose a record from the table to open");
    }
  }

  return (
    <MainLayout
      isEnableRightSidebar={true}
      onView={handleOnView}
      onAdd={handleOnCreate}
      onEdit={handleOnEdit}
    >
      <TopContent pageTitle={appLabel.GLMapping} pageItems={appStatic.GLMappingItems} />

      <Card
        title={`${appLabel.GLMapping} List`}
        // extra={
        //   <Col>
        //     <StatusSelect handleStatusChange={null} />
        //   </Col>
        // }
        style={{
          boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
          borderRadius: 20,
        }}
      >
        {/* RENDER TABLE LIST HERE*/}
        <Spin spinning={isLoading} size="large">
          <Row style={{ marginBottom: 20 }}>
            <div style={{ marginBottom: "auto" }}>
              <Text style={{ marginRight: 8 }}>Show</Text>
              <Select
                defaultValue={tableCount}
                options={[
                  { value: "5", label: "5" },
                  { value: "10", label: "10" },
                  { value: "25", label: "25" },
                  { value: "50", label: "50" },
                ]}
                onSelect={selectTableCount}
              />
              <Text style={{ marginLeft: 8 }}>Entries</Text>
            </div>
            <div style={{ margin: "0px 50px" }}>
              <Input
                onChange={handleSearchInTable}
                placeholder="Search by Financial Activity..."
                style={{
                  width: 400,
                }}
              />
            </div>
            {/* <DownloadTableButtons
              downloadData={glMappingList}
              columns={columns}
              fileName={"GL Mapping List"}
              onExportClick={getCsvListData}
            /> */}
          </Row>
          <Table
            rowSelection={{
              type: "radio",
              onChange: onSelectItemAction,
            }}
            columns={columns}
            dataSource={glMappingList}
            bordered
            pagination={{
              position: "bottomCentre",
              pageSize: tableCount,
            }}
          />
        </Spin>
      </Card>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
  rightBtn: state.RightSideBtn,
});

const mapDispatchToProps = { rightAction };
export default connect(mapStateToProps, mapDispatchToProps)(GLA0400);
